<div class="place-content-center">
  <div>
    <div class="flex items-center justify-between gap-x-2">
      <div>Call Payer</div>
      <div>{{ group().phoneNumber ?? '' | phoneNumber }}</div>
      <div class="relative flex items-center">
        <i class="pi pi-phone" style="font-size: 1.5rem"></i>
        @if (group().tasks[0].taskStatus !== taskItemStatus.Completed) {
          <div
            class="absolute -right-2 -top-3 h-5 w-5 content-center rounded-full bg-r1-blue-800 text-center text-xs text-white"
          >
            {{ group().tasks.length }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
